import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
  },
  action
) {
  switch (action.type) {
    case homeConstants.SAVE_USER_INSURANCE_REQUEST:
      return {
        data: null,
        isProgress: true,
      };
    case homeConstants.SAVE_USER_INSURANCE_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.SAVE_USER_INSURANCE_FAILURE:
      return {
        data: null,
        isProgress: false,
      };
    default:
      return state;
  }
}
